'use strict';

const setCurrentUserSettings = (state, settings) => {
  state.currentUserSettings = settings;
};

const setSoftPhoneSettings = (state, softPhoneSettings) => {
  state.softPhoneSettings = softPhoneSettings;
};

const setOfflineMode = (state, offlineMode) => {
  state.connectionSettings.offlineMode = offlineMode;
};

const updateCurrentUserDashboardSettings = (state, dashboardSettings) => {
  state.currentUserSettings.dashboardSettings = dashboardSettings;
};

const updateCurrentSupervisorWallboardSettings = (state, supervisorWallboardSettings) => {
  state.currentUserSettings.supervisorWallboardSettings = supervisorWallboardSettings;
};

const updateVersion = (state, applicationVersion) => {
  state.currentUserSettings.featuresSettings.latestShowedFeatures = applicationVersion;
};

const removeUserSettings = state => {
  state.softPhoneSettings = {};
};

export default {
  setCurrentUserSettings,
  setSoftPhoneSettings,
  setOfflineMode,
  updateCurrentUserDashboardSettings,
  updateCurrentSupervisorWallboardSettings,
  updateVersion,
  removeUserSettings
};
